import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import patientsService from "../../services/patients.service";

class SuccessComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect_uri: "/",
            registration_uri: '/complete_registration',
            is_loaded: false,
            country: null
        };
    }
    componentDidMount() {
        this.getCurrentPatient()
    }

    getCurrentPatient = async () => {
        try {
            let response = await patientsService.getCurrentPatient();
            this.setState({ authonticatedUser: response.data, is_loaded: true, country: response.data?.patientData?.country }, () => {
                if (this.state.is_loaded && this.state.country) {
                    return this.props.history.push(this.state.redirect_uri)
                } else {
                    return this.props.history.push(this.state.registration_uri)
                }
            })
        } catch (error) {
            this.props.history.push(this.state.redirect_uri)
            console.log(error);
        }
    }

    render() {
        return <div></div>
    }
}

const mapStateToProps = (state) => {
    return {
        currentPathName: state.Auth.currentPathName,
    };
};

export default connect(mapStateToProps)(SuccessComponent);
